<template>
  <v-dialog :value="downloadErrorDialog" persistent width="50%">
    <v-card>
      <v-card-text class="pt-4 pb-4">
        <v-layout row wrap class="px-3">
          <v-flex xs12 class="text-xs-center mb-3">
            <v-icon class="f3-5em k-orange-linear-text">fas fa-exclamation-triangle</v-icon>
          </v-flex>
          <v-flex xs12 class="text-xs-center f1-1em my-2">
            Ocurrió un error generando su archivo.
          </v-flex>
          <v-flex xs12 class="text-xs-center f1-1em my-2">
            Por favor intente nuevamente
          </v-flex>
          <v-flex>
            <v-layout class="h-100 ma-0" justify-end align-end>
              <v-btn flat  @click="$store.commit('SET_DOWNLOAD_ERROR_DIALOG', false)">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'downloadErrorDialog',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/DownloadErrorModal.vue